import {
  SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST,
  SUBMIT_CORPORATE_AND_ORG_STRUCTURE_SUCCESS,
  SUBMIT_CORPORATE_AND_ORG_STRUCTURE_FAILURE,
} from "../actions/corporateAndOrgStructureActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const corporateAndOrgStructureReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_CORPORATE_AND_ORG_STRUCTURE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_CORPORATE_AND_ORG_STRUCTURE_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default corporateAndOrgStructureReducer;
